<div class="modal-header border-0">
  <strong class="fs-4 text-center w-100">{{title}}</strong>
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<div class="col-11 mx-auto text-center mb-4" [innerHTML]="msg"></div>
<div class="col my-3 text-center">
  <button type="button" class="btn btn-primary" (click)="close()">{{button}}</button>
</div>